import { HttpError, unwrapLambdaResponse } from '@/lib/api';
import { BACKEND_URL } from '@/lib/constants';
import type { EditorTabKind } from './tab-registry';

export interface DocumentSummary {
  name: string;
  spaceId: string;
  spaceKind?: 'standard' | 'organization';
}

// Deck/workbook keys match the editors' own queries so tab names resolve
// from cache once an editor has loaded its document.
export function documentSummaryQueryKey(documentId: string, kind: EditorTabKind) {
  switch (kind) {
    case 'workbook':
      return ['workbook', documentId];
    case 'file':
      return ['space-file', documentId];
    default:
      return ['generated-deck', documentId];
  }
}

export async function fetchDocumentSummary(
  documentId: string,
  kind: EditorTabKind,
  getAccessToken: () => Promise<string | undefined>
): Promise<DocumentSummary> {
  const token = await getAccessToken();
  if (!token) throw new Error('Not authenticated');
  const path =
    kind === 'workbook'
      ? `/workbooks/${documentId}`
      : kind === 'file'
        ? `/files/${documentId}`
        : `/decks/${documentId}`;
  const res = await fetch(`${BACKEND_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new HttpError(res.status, 'Failed to load document');
  return unwrapLambdaResponse<DocumentSummary>(await res.json());
}
